import React from 'react';
import { hooks } from '../hooks';
import { custom } from '../custom';
import { useNavigate } from 'react-router-dom';

type Props = {
  item: any;
  isLast?: boolean;
  version?: number;
};

export const BrandCard: React.FC<Props> = ({ isLast, item, version = 1 }) => {
  const navigate = hooks.useAppNavigate();


  // Home > Brand item //
  if (version === 1) {
    return (
      <div
        className="w-[120px] sm:w-[140px] rounded-xl shadow-xl cursor-pointer m-2 border border-gray-300"
        onClick={() => {
          navigate(`/Shop/`, {
            state: {
              title: 'فروشگاه',
              filters: {
                brand: [item.id],
              }
            }
          });
        }}>
        <div className="w-full aspect-square rounded-t-xl overflow-hidden">
          <custom.ImageBackground
            imageUrl={item.image}
            style={{
              width: 120,
              height: 120,
              borderRadius: 12,
              marginBottom: 6,
              position: 'relative',
            }}
          >
            <></>
          </custom.ImageBackground>
        </div>
        <div className="text-center p-1">
          <p className="text-xs font-medium text-gray-700 truncate">{item.title}</p>
        </div>
      </div>
    );
  }

  return null;
};
interface DetailProps {
  item: any;
  isLast?: boolean;
  version?: number;
}

export const BrandCardDetail: React.FC<DetailProps> = ({ item, version = 1 }) => {
  const navigate = useNavigate();

  if (version !== 1) return null;

  const hasImage = !!item.image;

  return (
    <div
      onClick={() =>
        navigate('/Shop', {
          state: {
            title: 'فروشگاه',
            filters: { brand: [item.id] },
          },
        })
      }
      className="w-[48%] sm:w-[48%] md:w-[30%] custom722:w-[30%] lg:w-[22%] bg-white shadow-md hover:shadow-xl transition-transform hover:-translate-y-1 cursor-pointer border border-red-500 mb-8 rounded-xl flex flex-col overflow-hidden"
    >
      {/* بخش تصویر با ارتفاع ثابت */}
      <div className="relative w-full aspect-square">
        {hasImage ? (
          <img
            src={item.image}
            alt={item.title}
            className="absolute top-0 left-0 w-full h-full object-contain p-2"
          />
        ) : (
          <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center text-gray-400 text-sm">
            بدون تصویر
          </div>
        )}
      </div>

      {/* عنوان برند */}
      <div className="h-[60px] px-4 flex items-center justify-center text-center ">
        <h6 className="text-sm text-red-600 font-semibold leading-6">
          {item.title}
        </h6>
      </div>
    </div>
  );
};